import React from 'react';

import Button from '@material-ui/core/Button';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class Comp extends React.Component {
  render() {
  	return (
      <div style={{maxWidth:'600px',margin:'auto'}}>
        <div
          style={{
            maxWidth:'100%',
            display:'flex',
            flexDirection:'row',
            textAlign:'center',
            justifyContent:'space-around',
            alignItems:'center',
          }}
        >
          <div style={{flex:3}}>
          {
            (this.props.page > 1) &&
            <Button
              variant="outlined"
              color="primary"
              onClick={
                () => this.props.onClick(this.props.page - 1)
              }
              style={{width:'100%'}}
            >
              <ArrowBackIosIcon style={{padding:'5px',fontSize:'1.4em'}}/>
            </Button>
          }
          </div>
          <div style={{minWidth:'60px', flex:1, color:'#666'}}>
          {
            (this.props.page === 1 && this.props.isNext === false) ? (
              null
            ): (
              <div style={{padding:'0px 5px'}}>
                <div style={{fontSize:'1.2em',fontWeight:'900'}}>{this.props.page}</div>
                <div  style={{fontSize:'0.9em',}}>ページ</div>
              </div>
            )

          }
          </div>
          <div style={{flex:3}}>
          {
            (this.props.isNext === true) &&
            <Button
              variant="outlined"
              color="primary"
              onClick={
                () => this.props.onClick(this.props.page + 1)
              }
              style={{width:'100%'}}
            >
              <ArrowForwardIosIcon style={{padding:'5px',fontSize:'1.4em'}} />
            </Button>
          }
          </div>
        </div>
      </div>
  	)
  }
}

export default Comp;
